import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IResponsible, IResponsibleUser, ResponsibleType } from '@shared/interfaces';
import { PickerDirective } from '@shared/directives/picker.directive';
import { ReportingToolResponsibleSelectionComponent } from '@shared/components/reporting-tool-responsible-selection/reporting-tool-responsible-selection.component';

@Component({
    selector: 'reporting-tool-responsible-picker',
    templateUrl: './reporting-tool-responsible-picker.component.html',
    styleUrls: ['./reporting-tool-responsible-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReportingToolResponsiblePickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ReportingToolResponsiblePickerComponent extends PickerDirective {
    get singleValue(): ISimpleResponsible {
        return this.value as ISimpleResponsible;
    }

    get multipleValue(): ISimpleResponsible[] {
        return this.value as ISimpleResponsible[];
    }

    removeValue(item: IResponsible) {
        this.value = (this.value as IResponsible[]).filter(e => item.id !== e.id);
        this.propagateChange(this.value);
    }

    deleteSingleValue() {
        this.value = null;
        this.propagateChange(this.value);
    }

    openDialog() {
        this.dialog
            .open(ReportingToolResponsibleSelectionComponent, {
                position: { top: '50px' },
                panelClass: 'custom-dialog',
                data: { multiple: this.multiple, data: this.multiple ? this.multipleValue : [this.singleValue] }
            })
            .beforeClosed()
            .subscribe((e: IResponsible[]) => {
                if (e) {
                    if (!this.multiple) {
                        this.value = e[0];
                        this.propagateChange(this.value);
                    } else {
                        this.value = e;
                        this.propagateChange(this.value);
                    }
                }
            });
    }
}

export interface ISimpleResponsible {
    id: string;
    title: string;
    code: string;
    responsibleType: ResponsibleType;
    responsible?: IResponsibleUser[];
    specialists?: IResponsibleUser[];
}
